import React, { useMemo, useCallback } from 'react';
import { Button, Popover, Checkbox } from 'antd';
import { SettingOutlined } from '@ant-design/icons';
import { connect, useDispatch } from 'react-redux';
import { PlatformUtil } from 'utils/platform';
import { ServerAppSettings } from 'utils/server-app-settings';
import { ze } from 'utils/zhEn';
import { push as pushState } from 'connected-react-router';
import { generateSearch } from 'utils/helper';
import { PAGE_TYPE_CONVERT } from 'utils/constants';
import { ExceptionCategoryUtil } from 'utils/exception-category';

const VitalOrCrashConfigButton = ({
  reduxState,
}) => {
  const dispatch = useDispatch();
  const location = reduxState.router.location;

  const currentApp = useMemo(() => reduxState.app.get('current').toJS(), [reduxState.app.get('current')]);
  const { appId, pid } = currentApp;

  const serverAppSettings = reduxState.app.get('appIdToServerAppSettings')[appId] || {};
  //（仅支持ANR的端支持，例如安卓、鸿蒙）莉莉丝需求，是否开启"崩溃+ANR"合并的新指标。（界面上直接取代原来的崩溃指标，可以通过下拉切换原崩溃指标）
  const showVitalCategoryAsDefault = PlatformUtil.isAnrAvailable(pid) && !!serverAppSettings[ServerAppSettings.keys.showVitalCategoryAsDefault];

  const searchParams = useMemo(() => reduxState.summary.get('searchParams').toJS(), [reduxState.summary.get('searchParams')]);
  const {
    // 对于开启了vital大类（崩溃+ANR合并统计）的项目，大盘统计各个卡片：true: 查询合并vital指标 false：查询原始crash指标
    // --story=127642761 【CS】【莉莉丝】大盘崩溃统计新增崩溃+ANR合并模式
    isQueryVital,
  } = searchParams;

  const selectOptions = useMemo(() => reduxState.summary.get('selectOptions').toJS(), [reduxState.summary.get('selectOptions')]);
  const {
    pageType,
  } = selectOptions;

  const handleChange = useCallback((e) => {
    // 这边的处理方法跟定义在CrashSightHeader里面的subModuleId选择器一样，触发改变路由之后，由ProductSummaryPage里面的componentDidUpdate来触发后续重新拉取数据
    const query = {
      isQueryVital: e.target.checked,
    };
    dispatch(pushState({
      pathname: location.pathname,
      search: generateSearch(location.search, query),
    }));
  }, [dispatch, location.pathname, location.search]);

  if (!showVitalCategoryAsDefault) {
    return null;
  }

  const popoverContent = (
    <div style={{ padding: '8px 0' }}>
      <Checkbox
        checked={!!isQueryVital}
        onChange={handleChange}
      >
        {ze('显示崩溃与ANR合并数据', 'Display Merged Crash and ANR Stats')}
      </Checkbox>
    </div>
  );

  return (
    <Popover
      content={popoverContent}
      title={null}
      trigger="click"
      placement="bottomRight"
    >
      <Button
        icon={<SettingOutlined />}
        style={{ width: 28, height: 28, padding: 0 }}
        size="small"
      />
    </Popover>
  );
};

const mapStateToProps = state => ({
  reduxState: state,
});

export default connect(mapStateToProps)(VitalOrCrashConfigButton);
